import {
  GET_CLIENTS_LIST_IN_PROGRESS,
  GET_CLIENTS_LIST_SUCCESS,
  GET_CLIENTS_LIST_FAIL,
  GET_CLIENTS_COUNT_IN_PROGRESS,
  GET_CLIENTS_COUNT_FAIL,
  GET_CLIENTS_COUNT_SUCCESS,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  list: [],
  inProgress: false,
  error: false,
};

/**
 * Clients reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function clients(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_CLIENTS_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_CLIENTS_LIST_SUCCESS: {
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };
    }

    case GET_CLIENTS_LIST_FAIL:
      return {
        ...state,
        list: [],
        inProgress: false,
        error: true,
      };

    case GET_CLIENTS_COUNT_IN_PROGRESS:
      return {
        ...state,
        countInProgress: true,
        error: false,
      };

    case GET_CLIENTS_COUNT_SUCCESS:
      return {
        ...state,
        count: payload.count,
        countInProgress: false,
      };

    case GET_CLIENTS_COUNT_FAIL:
      return {
        ...state,
        count: 0,
        countInProgress: false,
        error: true,
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
